import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { keyframes, styled } from 'styled-components';
import { defaultTheme } from '@/theme';

type ProgressActivityProps = IconComponentBaseProps;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const RotatingSpinner = styled.svg`
  animation: ${rotate} 1s linear infinite;
`;

export const ProgressActivity = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: ProgressActivityProps) => {
  return (
    <RotatingSpinner
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7277_7552"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7277_7552)">
        <path
          d="M11.997 21.5C10.6965 21.5 9.46875 21.2508 8.31375 20.7525C7.15892 20.2542 6.15042 19.5739 5.28825 18.7118C4.42608 17.8496 3.74583 16.8411 3.2475 15.6863C2.74917 14.5313 2.5 13.3035 2.5 12.003C2.5 10.6867 2.74967 9.45358 3.249 8.30375C3.74833 7.15375 4.42817 6.14867 5.2885 5.2885C6.14867 4.42817 7.15733 3.74833 8.3145 3.249C9.47167 2.74967 10.7002 2.5 12 2.5C12.2125 2.5 12.3906 2.57192 12.5343 2.71575C12.6781 2.85958 12.75 3.03775 12.75 3.25025C12.75 3.46292 12.6781 3.641 12.5343 3.7845C12.3906 3.92817 12.2125 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7872 20.0719 11.609 20.2157 11.4655C20.3596 11.3218 20.5378 11.25 20.7502 11.25C20.9629 11.25 21.141 11.3219 21.2845 11.4658C21.4282 11.6094 21.5 11.7875 21.5 12C21.5 13.2998 21.2503 14.5283 20.751 15.6855C20.2517 16.8427 19.5718 17.8513 18.7115 18.7115C17.8513 19.5718 16.8462 20.2517 15.6962 20.751C14.5464 21.2503 13.3133 21.5 11.997 21.5Z"
          fill={fill}
        />
      </g>
    </RotatingSpinner>
  );
};
